/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import dayjs from "dayjs";
import { Button } from "@nordcloud/gnui";
import { useCreateResourceUpdatesReport } from "~/views/resources/hooks";

type GenerateUpdatesReportProps = {
  disabled?: boolean;
  resourceId?: string;
  resource?: {
    id: string;
    name?: string | null;
    os?: string | null;
  };
  reportPeriod: {
    startDate: string;
    endDate: string;
  };
  hasUpdates?: boolean;
};

export function GenerateUpdatesReport({
  disabled,
  resourceId,
  resource,
  reportPeriod,
  hasUpdates,
}: GenerateUpdatesReportProps) {
  const [createResourceUpdatesReport, loading] =
    useCreateResourceUpdatesReport();

  const handleExport = () => {
    const mutationInput = {
      resourceId: resourceId ?? resource?.id,
      startDate: reportPeriod.startDate,
      endDate: dayjs.utc().toISOString(),
    };

    if (mutationInput.resourceId) {
      createResourceUpdatesReport({
        resourceId: mutationInput.resourceId,
        startDate: mutationInput.startDate,
        endDate: mutationInput.endDate,
      });
    }
  };

  return (
    <Button
      onClick={handleExport}
      disabled={
        disabled ||
        loading ||
        !(resourceId ?? resource?.id) ||
        hasUpdates === false
      }
      severity="low"
      icon="download"
    >
      Get CSV Report
    </Button>
  );
}
